import _ from 'lodash'

var EphemeralDevice = function (key) {
  this.registrations = []
  this.activeTimeStamp = 0
  this.activeIndex = null
  this.key = key
}

EphemeralDevice.prototype.addRegistration = function (r) {
  var ts = parseInt(r.service_time.N)
  if (ts > this.activeTimeStamp) {
    this.activeTimeStamp = ts
    this.activeIndex = this.registrations.length
    this.registrations.push(r)
  } else {
    var existing = _.find(this.registrations, (o) => { return o.ephemeral_token.S === r.ephemeral_token.S })
    if (!existing) {
      this.registrations.push(r)
    }
  }
}

EphemeralDevice.prototype.getActiveString = function (s) {
  return this.registrations[this.activeIndex][s].S
}

EphemeralDevice.prototype.getActiveInt = function (s) {
  return parseInt(this.registrations[this.activeIndex][s].N)
}

EphemeralDevice.prototype.getActiveDate = function (s) {
  return new Date(this.getActiveInt(s))
}

export default EphemeralDevice



// WEBPACK FOOTER //
// ./src/store/EphemeralDevice.js